import { Link } from 'react-router-dom'
import reportingApi from '../../services/reportingApi'
import { T, page, usePoll, Empty } from './ui'

/**
 * Where every screen starts: which city is this display in?
 *
 * Nothing below this point shows another city's matches, because no screen is
 * in two places at once.
 */
const BoardHome = () => {
  const { data, error } = usePoll(() => reportingApi.context(), 30000, [])

  return (
    <div style={page}>
      <h2 style={{ margin: '0 0 4px', fontSize: 24 }}>Which city is this screen in?</h2>
      <p style={{ margin: '0 0 22px', color: T.muted, fontSize: 14, maxWidth: 620 }}>
        Pick the city, then the sport, then the court. The address bar remembers the
        choice, so a display set up once comes back to the same court on its own.
      </p>

      {error && <Empty>{error}</Empty>}
      {!data && !error && <Empty>Loading cities…</Empty>}

      <div style={{
        display: 'grid', gap: 12,
        gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
      }}>
        {data?.cities.map((c) => (
          <Link key={c.city} to={`/board/city/${encodeURIComponent(c.city)}`} style={{
            display: 'block', textDecoration: 'none', background: T.card,
            border: `1px solid ${c.live > 0 ? '#f0cdb4' : T.line}`,
            borderRadius: 12, padding: '16px 18px', color: T.ink,
          }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8,
            }}>
              <span style={{ fontSize: 18, fontWeight: 700 }}>{c.city}</span>
              {c.live > 0 && (
                <span style={{
                  padding: '3px 10px', borderRadius: 20, background: T.liveBg, color: T.live,
                  fontSize: 11.5, fontWeight: 800,
                }}>{c.live} live</span>
              )}
            </div>

            <div style={{ marginTop: 10, fontSize: 12.5, color: T.muted, display: 'flex', gap: 14 }}>
              <span>{c.sports} sports</span>
              <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                {c.played.toLocaleString('en-IN')} of {c.matches.toLocaleString('en-IN')} played
              </span>
            </div>

            <div style={{
              marginTop: 8, height: 4, borderRadius: 3, background: '#eef1f5', overflow: 'hidden',
            }}>
              <div style={{
                width: `${Math.round((c.played / Math.max(c.matches, 1)) * 100)}%`,
                height: '100%', background: T.accent,
              }} />
            </div>
          </Link>
        ))}
      </div>

      {data?.cities.length === 0 && <Empty>No fixtures have been drawn yet.</Empty>}
    </div>
  )
}

export default BoardHome
